import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngstack/translate";
import { FormBuilder, Validators } from "@angular/forms";
import { BIDService } from "src/app/services/common/bid.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  MatTableDataSource,
  MatSelectChange,
  MatDialog
} from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICourseType } from "src/app/interfaces/course-type";
//import { CIDService } from "src/app/services/common/cid.service";
import { IDiscountgGroup } from "src/app/interfaces/discount-group";
import { ErrorsService } from "src/app/services/common/errors.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { HoldingService } from "./../../../services/http/business/holding/holding.service";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { IListByJustCourseTypeId } from "../../../interfaces/termInfo-listByJustCourseTypeId";
import { IListCourseForRegister } from "src/app/interfaces/registration-listCourseForRegister";
// import { IBranchListByNaCodeAndPackage } from "src/app/interfaces/branchList-by-naCode-Package";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
// import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { ConfirmRegistrationEntryComponent } from "../confirm-registration-entry/confirm-registration-entry.component";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { environment } from "src/environments/environment";
import { HidService } from "src/app/services/common/hid.service";
import { HttpHeaders } from "@angular/common/http";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-registration",
  templateUrl: "./add-registration.component.html",
  styleUrls: ["./add-registration.component.css"]
})
export class AddRegistrationComponent implements OnInit, OnDestroy {
  data: any;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  levelId: number;
  courseId: number;
  isOwner: boolean;
  userInfo: string;
  userNationalCode: string;
  termInfoId: number;
  courseTypeId: number;
  errors = new Array();
  BaaseUrl = environment.BaaseUrl;
  nationalCode: string;
  branchList: IBranch[];
  selectedIndex: number;
  courseTypeName: string;
  allBranches: IBranch[];
  submitReg: boolean = true;
  BranchEncryptId: string;
  showTab: boolean = false;
  showTable: boolean = false;
  courseTypeList: ICourseType;
  showSubmit: boolean = false;
  nationalCodeform: FormGroup;
  termInfoTable: boolean = false;
  showCourseType: boolean = false;
  emptyTermInfoTable: boolean = false;
  queryParams: any;
  discountList: IDiscountgGroup[] = [];
  companyList: ICompany[];
  memorandumDiscountList = [];
  emptyPersonInfoTable: boolean = false;
  levels = [];
  showRegistrationTable: boolean = false;
  showlevelsCanBeRegistered = false;
  credit: any;
  model: any = {
    nationalCode: String,
    courseId: Number,
    levelId: Number,
    courseTypeId: Number,
    termInfoId: Number,
    branchEncryptId: String,
    discountGroupId: null,
    userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
    getUnderstandingDiscountId: null,
    courseTypeName: String
  };
  registrationData: any;
  level: any;
  baaseUrl = environment.BaaseUrl;

  personDiscountGroup: string;
  UnderstandingDiscount: string;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    // private cidService: CIDService,
    private bidService: BIDService,
    public translate: TranslateService,
    private paymentService: PaymentService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private branchService: BranchService,
    private accountService: AccountService,
    private termInfoService: TermInfoService,
    private courseTypeService: CourseTypeService,
    private hidService: HidService,
    private discountService: DiscountGroupService,
    private registrationService: RegistrationService,
    private companyService: CompanyService,
    // private studentService: StudentService,
    // private educationService: EducationPackageService
  ) { }

  ngOnInit() {
    this.queryParams = {
      holdingEncryptId: this.hidService.getHID()
    };
    this.checkOwner();
    this.createNaCodeForm();

  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      this.getCompanyList();
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    //this.bidService.setBID("");
    this.getBranchList(e.value);
  }

  createNaCodeForm() {
    this.nationalCodeform = this.fb.group({
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ]
    });

  }

  // table datasource
  displayedColumns: string[] = [
    "radio",
    this.translate.get("label.educationPackage"),
    this.translate.get("label.level")
  ];
  dataSource = new MatTableDataSource();

  getUserInfo(data: any) {

    this.errors = new Array();
    this.accountService.getSimpleUserInfo(data.NationalCode).subscribe(
      res => {
        //this.showlevelsCanBeRegistered = true;
        this.userNationalCode = data.NationalCode;
        this.nationalCode = data.NationalCode;
        this.getWallet(data.NationalCode);
        this.showSubmit = true;
        this.userInfo = res.FullName;
        this.showTable = false;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }
  // برای کاربران غیر دانشجو
  getWallet(nationalCode: any): void {
    this.paymentService.getWallet(nationalCode).subscribe(
      res => {

        this.credit = res.CreditCompany;
      },

    );
  }
  getListLevelFromNationalCode() {

    this.errors = new Array();
    this.registrationService
      .getListLevelFromNationalCode(this.nationalCode)
      .subscribe(
        res => {

          if (res.length == 0) {
            this.emptyPersonInfoTable = true;
            this.showlevelsCanBeRegistered = false;
          }
          else {
            this.data = res;
            this.showTable = true;
            this.dataSource = res;
            this.levels = res;
            this.emptyPersonInfoTable = false;
            this.showlevelsCanBeRegistered = true;
          }
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error)
        }
      );
  }

  // onItemChange(e: any) {
  //
  //   this.levelId = e.target.value;
  //   this.data = this.data.filter(r => r.LevelId == e.target.value);
  // }
  onItemChange(item: any) {
    this.model.levelId = item.LevelId;
    this.level = this.data.find(level => level.LevelId == item.LevelId);
    this.nextTab();
  }

  nextTab() {

    this.showTab = true;
    this.selectedIndex = 1;
    if (!this.isOwner) {
      this.getBranchList(this.cidService.getCID());
    }

  }

  onLinkClick(e) {

    this.selectedIndex = e.index;
  }

  getBranchList(company) {
    if (!this.isOwner) {
      // let data: IBranchListByNaCodeAndPackage = {
      //   NationalCode: this.nationalCode,
      //   PackageId: this.level.PackageId
      // };
      // this.educationService
      //   .getBranchListByNationalCodeAndPackage(data)
      //   .subscribe(res => {
      //     this.branchList = res;
      //   });

      var headers = new HttpHeaders({
        "Content-Type": "application/json"
      })
        .append("Authorization", "Bearer " + localStorage.getItem("token"))
        .append(
          "HID",
          localStorage.getItem("holdingCode")
            ? localStorage.getItem("holdingCode")
            : ""
        )
        .append(
          "CID",
          this.cidService.getCID()
        );


      this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
        res => {
          this.branchList = res.DataList;
        },
        () => {
          this.errorService.transactionError();
        }
      );

    }
    else {

      var headers = new HttpHeaders({
        "Content-Type": "application/json"
      })
        .append("Authorization", "Bearer " + localStorage.getItem("token"))
        .append(
          "HID",
          localStorage.getItem("holdingCode")
            ? localStorage.getItem("holdingCode")
            : ""
        )
        .append(
          "CID",
          company
        );


      this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
        res => {
          this.branchList = res.DataList;
        },
        () => {
          this.errorService.transactionError();
        }
      );
    }
  }

  // loadCourseType(e: MatSelectChange) {

  //   //this.bidService.setBID(e.value);
  //   this.BranchEncryptId = e.value;
  //   this.courseTypeService.courseTypeListByCurentBranch().subscribe(res => {

  //     this.showCourseType = true;
  //     this.courseTypeList = res;
  //   });
  // }



  loadCourseType(e: MatSelectChange) {
    this.termInfoDataSource = new MatTableDataSource();
    this.registrationDataSource = new MatTableDataSource();
    this.queryParams["branchEncryptId"] = e.value;
    this.queryParams["LevelInfoId"] = this.model.levelId;
    this.BranchEncryptId = e.value;
    this.courseTypeService.coursesTypeByCurentBranchAndLevel(this.queryParams).subscribe(res => {

      this.showCourseType = true;
      this.courseTypeList = res;
      if (!res || res.length <= 0) {
        this.snackBar.OpenSnackBar(
          'دوره فعالی برای این سطح وجود ندارد',
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    });
  }

  ///term info data source
  termDisplayedColumns: string[] = [
    "radio",
    this.translate.get("label.termNumber"),
    this.translate.get("label.termName"),
    this.translate.get("label.termStartTime"),
    this.translate.get("label.termEndTime")
  ];
  termInfoDataSource = new MatTableDataSource();

  loadTermInfo(e: MatSelectChange) {
    this.registrationDataSource = new MatTableDataSource();
    if (this.emptyTermInfoTable) {
      this.emptyTermInfoTable = false;
    }
    this.courseTypeName = e.value.Title;
    this.courseTypeId = e.value.Id;
    var data: IListByJustCourseTypeId = {
      CourseTypeId: e.value.Id,
      xPage: 1,
      xPageSize: 5,
      xOrderBy: "",
      xOrderDesc: true,
      BranchEncryptId: this.BranchEncryptId
    };
    this.termInfoService.listByJustCourseTypeId(data).subscribe(
      res => {

        if (res.Total == 0) {
          this.emptyTermInfoTable = true;
          this.termInfoTable = false;
        } else {
          this.termInfoTable = true;
          this.termInfoDataSource = res.DataList;
        }
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  paginatorEvent(event) {
    var data: IListByJustCourseTypeId = {
      CourseTypeId: this.courseTypeId,
      xPage: event.pageIndex + 1,
      xPageSize: event.pageSize,
      xOrderBy: "",
      xOrderDesc: true,
      BranchEncryptId: this.BranchEncryptId
    };
    this.termInfoService.listByJustCourseTypeId(data).subscribe(res => {
      this.dataSource = res.DataList;
    });
  }

  //registration Table Datasource

  registrationDisplayedColumns: string[] = [
    "radio",
    this.translate.get("label.patternName"),
    this.translate.get("label.teacherName"),
    this.translate.get("label.startDate"),
    this.translate.get("label.endDate"),
    this.translate.get("label.startTime"),
    this.translate.get("label.endTime"),
    this.translate.get("label.price"),
    this.translate.get("label.discount"),
    this.translate.get("label.capacity"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.gender")
  ];
  registrationDataSource = new MatTableDataSource();
  registrationas = [];

  OntermInfo(e: any) {

    this.submitReg = false;
    this.termInfoId = e.target.value;
    var data: IListCourseForRegister = {
      NationalCode: this.userNationalCode,
      TermInfoId: this.termInfoId,
      CourseTypeId: this.courseTypeId,
      BranchEncryptId: this.BranchEncryptId,
      LevelInfoId: this.model.levelId,
      Id: 0,
      xPage: 0,
      xPageSize: 0,
      xOrderBy: "",
      xOrderDesc: true
    };
    this.registrationService.listCourseForRegister(data).subscribe(
      res => {

        this.showRegistrationTable = true;

        this.registrationas = res;
        this.registrationDataSource = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCourseId(event: any) {

    this.courseId = event.target.value;
    // this.registrationData = e.target.value;
    this.getDiscount();
    this.getUnderstandingDiscountCombo();
  }

  // getDiscount() {
  //   this.discountService.discountPersonList({courseId: this.courseId}).subscribe(res => {
  //
  //     this.discountList = res;
  //     this.discountList = res;
  //     if (this.discountList.length == 0)
  //       this.discountGroupId=null;
  //   });
  // }

  // getUnderstandingDiscountCombo() {
  //   this.studentService.getUnderstandingDiscountCombo(this.model)
  //   .subscribe(res => {
  //
  //     this.memorandumDiscountList = res;
  //     if (this.memorandumDiscountList.length == 0)
  //       this.model.getUnderstandingDiscountId=null;

  //   });
  // }
  getDiscount() {
    this.discountService.discountPersonByNationalCode(this.courseId, this.nationalCode).subscribe(res => {

      // this.discountList = res;
      // if (this.discountList.length == 0)
      //   this.model.discountGroupId = null;
      debugger;
      if (res && res.length > 0) {
        this.discountList = res
        var dis = res.reduce(function (prev, current) {
          return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
        })

        // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
        this.model.discountGroupId = dis.Id;
        this.personDiscountGroup = dis.Title;
      }
      else {
        this.model.discountGroupId = null;
      }

    });
  }

  getUnderstandingDiscountCombo() {
    this.discountService.getUnderstandingDiscountCombo(this.courseId, this.nationalCode)
      .subscribe(res => {
        debugger
        this.memorandumDiscountList = res;
        if (res && res.length > 0) {

          var dis = res.reduce(function (prev, current) {
            return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
          })

          // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
          this.model.getUnderstandingDiscountId = dis.Id;
          this.UnderstandingDiscount = dis.CustomerTitle + ' / ' + dis.ContractName;
        }
        else {
          this.model.getUnderstandingDiscountId = null;
        }

        // this.memorandumDiscountList = res;
        // if (this.memorandumDiscountList.length == 0)
        //   this.model.getUnderstandingDiscountId = null;


        // this.memorandumDiscountList = res;
        // if (this.memorandumDiscountList.length == 0)
        //   this.model.getUnderstandingDiscountId = null;

      });
  }


  // getDiscount() {
  //   this.studentService.discountPersonList(this.model).subscribe(res => {
  //     if (res && res.length > 0) {
  //       this.discountList = res
  //       var dis = res.reduce(function (prev, current) {
  //         return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
  //       })

  //       // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
  //       this.model.discountGroupId = dis.Id;
  //       this.personDiscountGroup = dis.Title;
  //     }
  //     else {
  //       this.model.discountGroupId = null;
  //     }
  //     //   this.discountList = res;
  //     //   if (this.discountList.length == 0)
  //     // });
  //   })
  // }

  // getUnderstandingDiscountCombo() {
  //   this.studentService.getUnderstandingDiscountCombo(this.model)
  //     .subscribe(res => {
  //       this.memorandumDiscountList = res;
  //       if (res && res.length > 0) {

  //         var dis = res.reduce(function (prev, current) {
  //           return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
  //         })

  //         // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
  //         this.model.getUnderstandingDiscountId = dis.Id;
  //         this.UnderstandingDiscount = dis.Title;
  //       }
  //       else {
  //         this.model.getUnderstandingDiscountId = null;
  //       }

  //       // this.memorandumDiscountList = res;
  //       // if (this.memorandumDiscountList.length == 0)
  //       //   this.model.getUnderstandingDiscountId = null;

  //     });
  // }

  getStyle(e: any): string {
    if (e.RegisterCount <= (e.MaxCapacity * 30 / 100))
      return '#B3CEFF';

    else if (e.RegisterCount > (e.MaxCapacity * 30 / 100) && e.RegisterCount <= (e.MaxCapacity * 60 / 100))
      return '#5AFA53';

    else if (e.RegisterCount > (e.MaxCapacity * 60 / 100) && e.RegisterCount < e.MaxCapacity)
      return '#FFD22D';

    else //(e.RegisterCount == e.Capacity)
      return '#FF8080';
  }



  register() {

    var registerData = {
      NationalCode: this.nationalCode,
      CourseId: this.courseId,
      LevelInfoId: this.model.levelId,
      CourseTypeId: this.courseTypeId,
      TermInfoId: this.termInfoId,
      BranchEncryptId: this.BranchEncryptId,
      DiscountGroupId: this.model.discountGroupId,
      GetUnderstandingDiscountId: this.model.getUnderstandingDiscountId,
      Fullname: this.userInfo,
      registrationData: this.registrationas.find(x => x.Id == this.courseId),
      courseTypeName: this.courseTypeName
    };
    this.dialog.open(ConfirmRegistrationEntryComponent, {
      data: registerData
    });
  }

  ngOnDestroy(): void {
    if (this.isOwner)
      this.bidService.setBID("");
  }
}
